var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-justify-center flex-align-center border border-radius-10 bg-darkCobalt fg-white c-pointer py-1 px-5 bd-lightCobalt",attrs:{"id":"btn_cupon"},on:{"click":function($event){return _vm.crear_cupon()}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"fa-solid fa-tags mr-1"}),_c('span',[_vm._v("Cupones de Puntos")])])
}]

export { render, staticRenderFns }